export default __webpack_public_path__ + "static/media/1063.2afc4249.png";